<template lang="pug">
.admin-form__summary(
  ref="summaryRef",
  tabindex="-1",
  role="alert",
  aria-live="polite"
)
  p.admin-form__summary-title {{ title }}
  ul
    li(v-for="error in errors", :key="error.prop")
      a(
        :href="`#${fieldElementId(error.prop)}`",
        @click.prevent="emit('select', error.prop)"
      ) {{ error.message }}
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { SubmissionError } from "./types";

defineProps<{
  errors: SubmissionError[];
  title: string;
}>();

const emit = defineEmits<{
  select: [prop: string];
}>();

const summaryRef = ref<HTMLElement>();

function fieldElementId(prop: string): string {
  return `admin-form-field-${prop.replaceAll(/[^a-zA-Z0-9_-]/g, "-")}`;
}

function focus(): void {
  summaryRef.value?.focus();
}

defineExpose({ focus });
</script>

<style scoped>
.admin-form__summary {
  background: var(--el-color-danger-light-9);
  border: 1px solid var(--el-color-danger-light-5);
  border-radius: 4px;
  color: var(--el-color-danger);
  margin-bottom: 1rem;
  padding: 1rem;
}

.admin-form__summary-title {
  font-weight: 700;
  margin: 0 0 0.5rem;
}

.admin-form__summary ul {
  margin: 0;
  padding-left: 1.25rem;
}
</style>
